import { getTemplate } from "../template-helper";
import { tr } from "../../util/locales" ;
import { getFieldAndBindPath } from "../../util/schema-helper.js";

const COMPONENT_NAME = "z-field" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class FieldComponent extends HTMLElement {
            constructor() {
                super();
                this.zFieldOnly = this.querySelector("z-field-only") ;
                if(!this.zFieldOnly){
                    this.manualLabel = this.querySelector("label") ;
                    const cols = Array.prototype.slice.apply(this.querySelectorAll("z-col")) ;
                    this.innerHTML = "" ;
                    const clone = document.importNode(template.content, true);
                    this.appendChild(clone);
    
                    let div = this.querySelector("div") ;
                    this.div = div ;
                    this.zFieldOnly = this.querySelector("z-field-only") ;

                    for(let col of cols){
                        this.zFieldOnly.appendChild(col) ;
                    }
    
                    const modelPath = this.getAttribute("z-model") ;
    
                    this.zFieldOnly.setAttribute("z-model", modelPath) ;

                    if(this.hasAttribute("z-bind")){
                        this.zFieldOnly.setAttribute("z-bind", this.getAttribute("z-bind")) ;
                        this.removeAttribute("z-bind") ;
                    }
                    if(this.hasAttribute("z-default-value")){
                        this.zFieldOnly.setAttribute("z-default-value", this.getAttribute("z-default-value")) ;
                        this.removeAttribute("z-default-value") ;
                    }

                    if(modelPath){
                        let field;
                        if(modelPath[0]==="{"){
                            try{
                                field = JSON.parse(modelPath);
                            }catch(err){
                                //ignore
                            }
                        }else{
                            let fieldAndBindPath = getFieldAndBindPath(modelPath, this.getAttribute("z-app")) ;
                            field = fieldAndBindPath.field;
                        }
                        if(field && field.type === "checkbox"){
                            let label = this.querySelector("label") ;
                            div.appendChild(label) ;
                            div.classList.add("form-check") ;
                            label.classList.add("form-check-label") ;
                        }
                        if(field){
                            if(field.type){
                                this.setAttribute("z-field-type", field.type) ;
                                if(field.htmlType){
                                    this.setAttribute("z-html-type", field.htmlType) ;
                                }
                            }else if(field.submodel){
                                this.setAttribute("z-field-type", "one2many") ;
                            }
                        }
                    }


                }else{
                    this.zFieldOnly = this.querySelector("z-field-only") ;
                }

                if(this.customValidity){
                    this.zFieldOnly.setCustomValidity(this.customValidity) ;
                }
                this.applyReadonly() ;
                this.applyPlaceholder() ;
                this.applyRequired() ;
                this.applyCopyAttr() ;
                this.applyLabel() ;
            }

            // connectedCallback(){
            //     this.zFieldOnly = this.querySelector("z-field-only") ;
                
            //     if(this.zFieldOnly.field){
            //         if(this.zFieldOnly.field.type){
            //             this.setAttribute("z-field-type", this.zFieldOnly.field.type) ;
            //             if(this.zFieldOnly.field.htmlType){
            //                 this.setAttribute("z-html-type", this.zFieldOnly.field.htmlType) ;
            //             }
            //         }else if(this.zFieldOnly.field.submodel){
            //             this.setAttribute("z-field-type", "one2many") ;
            //         }
            //     }

            //     this.applyReadonly() ;
            //     this.applyPlaceholder() ;
            //     this.applyRequired() ;
            //     this.applyCopyAttr() ;
            //     this.applyLabel() ;
            // }

            static get observedAttributes() {
                return ["readonly", "value", "required", "z-no-auto-update", 
                    "pattern", "z-label", "placeholder", "z-model", "z-col-def"];
            }
    
            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'readonly':
                        this.applyReadonly();
                        break;
                    case 'z-model':
                        if(this.zFieldOnly) {
                            this.zFieldOnly.setAttribute("z-model", newValue);
                        }
                        break;
                    case 'required':
                        this.applyRequired();
                        break;
                    case 'placeholder':
                        this.applyPlaceholder();
                        break;
                    case 'z-label':
                        this.applyLabel();
                        break;
                    case 'z-no-auto-update':
                    case 'z-col-def':
                    case 'pattern':
                        this.applyCopyAttr();
                        break;
                    case 'value':
                        this.value = newValue;
                        break;
                }
            }

            get value() {
                if(!this.zFieldOnly){
                    return null;
                }
                return this.zFieldOnly.value ;
            }
            
            set value(value) {
                if(!this.zFieldOnly){ 
                    return ; 
                }
                this.zFieldOnly.value = value ;
            }

            get readonly() {
                return this.hasAttribute("readonly") ;
            }
            
            set readonly(readonly) {
                if(readonly){
                    this.setAttribute('readonly', "readonly");
                }else{
                    this.removeAttribute('readonly');
                }
            }

            get required() {
                return this.hasAttribute("required") ;
            }
            
            set required(required) {
                if(required){
                    this.setAttribute('required', "required");
                }else{
                    this.removeAttribute('required');
                }
            }
    
            get placeholder() {
                return this.getAttribute("placeholder") ;
            }
            
            set placeholder(placeholder) {
                this.setAttribute('placeholder', placeholder||"");
            }
    
            applyLabel(){
                let label = this.querySelector("label") ;
                const modelPath = this.getAttribute("z-model") ;


                if(this.manualLabel){
                    const manualAttributes = this.manualLabel.attributes ;
                    for(let a=0; a<manualAttributes.length; a++){
                        label.setAttribute(manualAttributes[a].name, manualAttributes[a].value) ;
                    }
                    label.innerHTML = this.manualLabel.innerHTML ;
                    this.setAttribute("z-label", this.manualLabel.innerHTML ) ;
                }else if(this.hasAttribute("z-label")){
                    label.innerHTML = this.getAttribute("z-label") ;
                }else if (modelPath && modelPath[0]!=="{"){
                    const trKey = "models."+modelPath ;
                    let labelStr = tr(trKey) ;
                    if(labelStr === trKey){
                        //not in translations
                        
                        const modelPathSplitted = modelPath.split(".") ;
                        const modelName = modelPathSplitted.shift() ;
                        const modelDef = window.APP.schema.models.find(m => m.name === modelName) ;
                        if(modelDef){
                            let columns = modelDef.columns ;
                            let fieldName = modelPathSplitted.shift();
                            const field = columns.find(m => m.name === fieldName) ;
                            if(field){
                                labelStr = field.label ;
                            }
                        }
                    }
                    label.innerHTML = labelStr ;
                }
            }

            applyReadonly(){
                if(!this.zFieldOnly){ return ;}
                if(this.readonly) {
                    this.zFieldOnly.setAttribute("readonly", "readonly");
                } else {
                    this.zFieldOnly.removeAttribute("readonly");
                }
            }
            applyPlaceholder(){
                if(!this.zFieldOnly){ return ;}
                this.zFieldOnly.setAttribute("placeholder", this.placeholder||"");
            }

            setCustomValidity(msg){
                this.customValidity = msg ;
                if(this.zFieldOnly){
                    this.zFieldOnly.setCustomValidity(msg) ;
                }
            }

            applyRequired(){
                if(!this.zFieldOnly){ return ;}
                if(this.required) {
                    this.zFieldOnly.setAttribute("required", "required");
                } else {
                    this.zFieldOnly.removeAttribute("required");
                }
                if(!this.zFieldOnly){ return ;}
            }
            applyCopyAttr(){
                if(this.zFieldOnly){
                    ["z-no-auto-update", "pattern", "z-search-choose-label", "z-no-empty-search",
                        "z-form-url", "z-form-create-url", "z-form-popup-size", "z-no-new-line-auto",
                        "z-search-filter", "z-search-order-by", "z-col-def", "z-media-max-size", "z-media-max-width", "z-media-jpeg-quality", 
                        "z-decimaldigits", "accept"
                        ].forEach((attr)=>{
                        if(this.hasAttribute(attr)){
                            this.zFieldOnly.setAttribute(attr, this.getAttribute(attr)) ;
                        }else{
                            this.zFieldOnly.removeAttribute(attr) ;
                        }
                    }) ;
                    let attrs = this.attributes ;
                    for(let attr of attrs){
                        if([/^z-picker-option-/, /^z-mask-option-/].some(re=>re.test(attr.name))){
                            this.zFieldOnly.setAttribute(attr.name, attr.value) ;
                        }
                    }
                }
            }

            updateValue(){
                if(this.zFieldOnly){
                    this.zFieldOnly.updateValue.apply(this.zFieldOnly, arguments) ;
                }
            }

            focus(){
                if(this.zFieldOnly){
                    this.zFieldOnly.focus() ;
                }
            }

            setValue(value){
                if(this.zFieldOnly){
                    this.zFieldOnly.setValue(value) ;
                }
            }
        }
        customElements.define(COMPONENT_NAME, FieldComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}
